import "../register/RegisterPage.scss";
import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { env } from "../../env/env";
import { LogRegLogo } from "../util/LogRegLogo";
import { ReactComponent as MicrosoftIcon } from "../register/icons/microsoft.svg";
import RegisterPageLeft from "../register/RegisterPageLeft";
import { RegStep } from "../register/RegisterPage";
import Storage from "../../util/Storage";

// Per-customer display label for the SSO button. Falls back to a generic label for unknown slugs.
const PROVIDER_LABELS: Record<string, string> = {
  benchmark: "Benchmark",
};

// Friendly messages for the ssoError codes the backend redirects back with.
const ERROR_MESSAGES: Record<string, string> = {
  account_not_found: "We couldn't find a MustHaveMenus account for your sign-in. Please contact your administrator.",
  no_invitation: "You haven't been invited to MustHaveMenus yet. Please ask your administrator to send you an invite.",
  org_not_enabled: "Your organization isn't enabled for single sign-on. Please contact your administrator.",
  access_denied: "Sign-in was cancelled.",
};

export default function EnterpriseSsoPage() {
  const { provider = "" } = useParams<{ provider: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Already signed in — skip the SSO screen and go straight to the dashboard.
  useEffect(() => {
    if (Storage.getToken()) {
      navigate(`${env.dashboardPath}/designs`, { replace: true });
    }
  }, [navigate]);

  const label = PROVIDER_LABELS[provider] || "your organization";
  const errorCode = searchParams.get("ssoError");
  const errorMessage = errorCode
    ? (ERROR_MESSAGES[errorCode] || "We couldn't sign you in. Please try again or contact your administrator.")
    : "";

  const startSso = () => {
    window.location.href = `${env.apiPath}/public/oidc/${provider}/authorize`;
  };

  return (
    <div className={"reg-page"}>
      <div className={"left"}>
        <RegisterPageLeft step={RegStep.Login} />
      </div>
      <div className={"right"}>
        <div className={"step-type step full"}>
          <LogRegLogo />
          <h2>Sign in to MustHaveMenus</h2>
          <h5>Continue with your {label} account.</h5>
          {errorMessage && (
            <p className="sso-error" style={{ color: "#ff4d4f", textAlign: "center", marginBottom: 16 }}>{errorMessage}</p>
          )}
          <div className="login-buttons">
            <div onClick={startSso}>
              <MicrosoftIcon />
              <span className={"login-option"}>Continue with {label}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
